const Empty = () => <div className="px-6 py-16 text-center">没有搜索历史</div>;
export default Empty;
